import React, { useState } from "react";
import MilanoWind from "../imgs/MilanoWindEnsemble.png";
import MilanoWind2 from "../imgs/windensemble2.jpg";
import Audio1 from "../audio/FestivalPrelude.mp3";
import Audio2 from "../audio/WindofChange.mp3";
import Audio3 from "../audio/LincolnshirePosy.mp3";
import Audio4 from "../audio/SHELTERINGSKY.mp3";
import Audio5 from "../audio/IMPERATRIX.mp3";
import Audio6 from "../audio/Undertow.mp3";
import Audio7 from "../audio/ALittleNightandDay.mp3";
import Audio8 from "../audio/MarchtoMars.mp3";
import Brochure from "../imgs/2024-brochureWE.pdf";
import VillaScheibler from "../imgs/VillaScheibler.png";
import CarloPirola from "../imgs/Carlo_Pirola_Milarte.pdf";
import VideoLocandina from "../video/Video-locandina.mp4";

const WindEnsemble = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  return (
    <div className="flex flex-col items-center w-full ">
      <p className="text-red-600 font-extrabold xs:text-2x1 md:text-3xl">
        MILANO Wind Ensemble
      </p>
      <img src={MilanoWind} />
      {/* <a href={VideoLocandina}/> */}
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          openModal();
        }}
      >
        <img src={MilanoWind2} alt="Milano Wind 2" className="cursor-pointer" />
      </a>
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
          <div className=" rounded-lg  xs:w-5/6 md:w-4/6 relative">
            <button onClick={closeModal} className="  text-white rounded-full">
              X
            </button>
            <div className="w-full h-full">
              <video width="100%" height="100%" controls>
                <source src={VideoLocandina} type="video/mp4" />
              </video>
            </div>
          </div>
        </div>
      )}
      {/* <img src={MilanoWind2} /> */}
      <div className="flex flex-col">
        <p>
          Consulente artistico:{" "}
          <strong className="text-red-600">Carlo Pirola</strong>
        </p>
        <p>
          Direttore musicale:{" "}
          <strong className="text-red-600">Paolo Casiraghi</strong>
        </p>
        <p>
          Direttore sostituto:
          <strong className="text-red-600"> Marco Maiello</strong>
        </p>
        <p>
          Sovrintendenti:{" "}
          <strong className="text-red-600">
            Roberto Lonoce e Vittorio Giola
          </strong>{" "}
        </p>
      </div>
      <div className="flex flex-col items-center mt-8 w-3/4">
        <p>
          MILANO Wind Ensemble è l’orchestra di fiati concepita come esperimento
          di avanguardia: l’intento è di esplorare una letteratura musicale
          innovativa, scarsamente eseguita in Italia, proponendo un'originale e
          attraente connotazione a parti reali. L’organico è caratterizzato da
          chiarezza timbrica e flessibilità. Il repertorio per Wind Ensemble,
          inizialmente prodotto in ambito americano, è in fase di crescita anche
          nel contesto musicale europeo.
        </p>
        <p className="mt-4">
          Brani esemplificativi del nostro percorso artistico:
        </p>
        <div className="flex flex-col">
          <div className="flex place-items-center mt-4 justify-between	">
            <strong>A Festival Prelude di Alfred Reed</strong>
            <audio controls src={Audio1} type="audio/mpeg" />
          </div>
          <div className="flex place-items-center mt-4 justify-between	">
            <strong>Winds of Change di Randall D. Standridge</strong>
            <audio controls src={Audio2} type="audio/mpeg" />
          </div>
          <div className="flex place-items-center mt-4 justify-between	">
            <strong>Lincolnshire Posy di Percy Grainger</strong>
            <audio controls src={Audio3} type="audio/mpeg" />
          </div>
          <div className="flex place-items-center mt-4 justify-between	">
            <strong>Sheltering sky di John Mackey</strong>
            <audio controls src={Audio4} type="audio/mpeg" />
          </div>
          <div className="flex place-items-center mt-4 justify-between	">
            <strong>Imperatrix di Alfred Reed</strong>
            <audio controls src={Audio5} type="audio/mpeg" />
          </div>
          <div className="flex place-items-center mt-4 justify-between	">
            <strong>Undertow di John Mackey</strong>
            <audio controls src={Audio6} type="audio/mpeg" />
          </div>
          <div className="flex place-items-center mt-4 justify-between	">
            <strong>A little night and day music di Samuel Adler</strong>
            <audio controls src={Audio7} type="audio/mpeg" />
          </div>
          <div className="flex place-items-center mt-4 justify-between	">
            <strong>March to Mars di Julius Steffaro</strong>
            <audio controls src={Audio8} type="audio/mpeg" />
          </div>
        </div>
        <p className="mt-4">
          In futuro si desidera promuovere nuova musica: l’esecuzione di brani
          inediti diviene opportunità, per giovani compositori, di lavorare con
          gli stessi esecutori al fine di sperimentare originali esperienze
          musicali. Carlo Pirola, compositore e direttore di eccellente
          levatura, collabora al progetto in qualità di consulente musicale.
        </p>
        <a href={Brochure}>Scarica la brochure</a>
      </div>

      <div className="mt-8 flex flex-col items-center w-full">
        <p className="text-red-600 font-bold xs:text-xl md:text-2xl">
          Organico
        </p>
        <div className="mt-4 flex flex-row items-center w-3/4 justify-evenly">
          <div>
            <p>Chiara Pasqualini</p>
            <p>Paola Terenzio</p>
          </div>
          <p>Flauto</p>
        </div>
        <div className="mt-4 flex flex-row items-center w-3/4 justify-evenly">
          <div>
            <p>Martina Frisenna</p>
            <p>Antonella Varvara</p>
          </div>
          <p>Oboe</p>
        </div>
        <div className="mt-4 flex flex-row items-center w-3/4 justify-evenly">
          <div>
            <p>Andreana Pinna</p>
            <p>Aurora Pinese</p>
          </div>
          <p>Sax contratto</p>
        </div>
        <div className="mt-4 flex flex-row items-center w-3/4 justify-evenly">
          <div>
            <p>Valentino Melloni</p>
          </div>
          <p>Sax tenore</p>
        </div>
        <div className="mt-4 flex flex-row items-center w-3/4 justify-evenly">
          <div>
            <p>Lara Fossati</p>
            <p>Pino Poidomani</p>
            <p>Mario Montani</p>
          </div>
          <p>Clarinetto</p>
        </div>
        <div className="mt-4 flex flex-row items-center w-3/4 justify-evenly">
          <div>
            <p>Miriam Marcone</p>
          </div>
          <p>Clarinetto basso</p>
        </div>
        <div className="mt-4 flex flex-row items-center w-3/4 justify-evenly">
          <div>
            <p>Davide Ancona</p>
            <p>Vittorio Giola</p>
          </div>
          <p>Fagotto</p>
        </div>
        <div className="mt-4 flex flex-row items-center w-3/4 justify-evenly">
          <div>
            <p>Davide Scarafile</p>
            <p>Giovanni Bazzini</p>
          </div>
          <p>Tromba</p>
        </div>
        <div className="mt-4 flex flex-row items-center w-3/4 justify-evenly">
          <div>
            <p>Andrea Franzini</p>
            <p>Sara Collodel</p>
          </div>
          <p>Trombone</p>
        </div>
        <div className="mt-4 flex flex-row items-center w-3/4 justify-evenly">
          <div>
            <p>Antonio Bonatesta</p>
            <p>Roberto Lonoce</p>
          </div>
          <p>Corno</p>
        </div>
        <div className="mt-4 flex flex-row items-center w-3/4 justify-evenly">
          <div>
            <p>Marco Fossati</p>
          </div>
          <p>Basso</p>
        </div>
        <div className="mt-4 flex flex-row items-center w-3/4 justify-evenly">
          <div>
            <p>Gabriele Venturelli</p>
            <p>Francesco Mauri</p>
          </div>
          <p>Percussioni</p>
        </div>
        <div className="mt-4 flex flex-row items-center w-3/4 justify-evenly">
          <div>
            <p>Katia Vestri</p>
          </div>
          <p>Tastiera</p>
        </div>
      </div>

      <table className="w-5/6 flex flex-col mt-8 border-2 rounded-lg border-red-600">
        <tr className="flex justify-evenly mt-5">
          <td className="w-1/2 self-center text-center">
            <p>Come candidarsi per suonare in</p>
            <p className="font-extrabold">Milano Wind Ensemble</p>
          </td>
          <td className="w-1/2 ">
            Per candidarsi inviare mail a{" "}
            <a
              href="mailto:windensemble@milarte.it"
              className="underline text-red-600 "
            >
              windensemble@milarte.it
            </a>{" "}
            specificando: Nome e Cognome N° telefono Strumento
          </td>
        </tr>
        <tr className="flex justify-evenly mt-5 border-t-2 border-red-600">
          <td className="self-center text-center w-1/2">
            Consulente artistico
          </td>
          <td className="items-center w-1/2 ">
            <a href={CarloPirola} className="text-red-600 underline">
              Carlo Pirola
            </a>
            , compositore già titolare della cattedra di Strumentazione per
            banda al Conservatorio Giuseppe Verdi di Milano. Supporta il
            progetto in particolare nella scelta del repertorio. QUI il link al
            Maestro
          </td>
        </tr>
        <tr className="flex justify-evenly mt-5 border-t-2 border-red-600">
          <td className="w-1/2 self-center text-center">Direttore musicale</td>
          <td className="w-1/2">
            <a
              href="https://www.conspaganini.it/users/paolo-casiraghi"
              className="underline text-red-600"
            >
              Paolo Casiraghi
            </a>
            , direttore d'orchestra. Qui il link al Maestro
          </td>
        </tr>
        <tr className="flex justify-evenly mt-5 border-t-2 border-red-600">
          <td className="w-1/2 self-center text-center">Direttore sostituto</td>
          <td className="w-1/2">Marco Maiello</td>
        </tr>
        <tr className="flex justify-evenly mt-5 border-t-2 border-red-600">
          <td className="w-1/2 self-center text-center">Sovrintendenti </td>
          <td className="w-1/2 flex flex-col">
            <a href="https://www.lonoce.com/">Roberto Lonoce </a>{" "}
            <a href="https://www.giola.it/">Vittorio Giola</a>
          </td>
        </tr>
        <tr className="flex justify-evenly mt-5 border-t-2 border-red-600">
          <td className="w-1/2 self-center text-center">
            Riferimenti culturali
          </td>
          <td className="w-1/2">
            Il modello di{" "}
            <p className="text-red-600 font-bold inline">Wind ensemble</p> ha
            origine in America da un’idea di Frederick Fennell. La proposta di
            un solo esecutore per ogni parte consente di ottenere sonorità più
            chiare e definite, nonché una particolare duttilità
            tecnico-espressiva, con attenzione all’utilizzo di strumenti
            inusuali (tastiera, sintetizzatore elettronico) e massima apertura
            ai linguaggi compositivi moderni e contemporanei.
          </td>
        </tr>
        <tr className="flex justify-evenly mt-5 border-t-2 border-red-600">
          <td className="w-1/2 self-center text-center">
            Letteratura musicale
          </td>
          <td className="w-1/2">
            Il repertorio è delineato soprattutto in ambito americano, da
            compositori del primo Novecento fino ai giorni nostri. Di
            particolare interesse l’attuale fase di crescita del repertorio
            americano e in parte, di quello europeo. Con questo tipo di
            organico, caratterizzato da chiarezza timbrica e flessibilità, si
            può inoltre commissionare nuova musica o eseguire brani in fase di
            pubblicazione, offrendo opportunità ai compositori di lavorare con
            gli stessi esecutori e quindi di sperimentare originali esperienze
            musicali.
          </td>
        </tr>
        <tr className="flex justify-evenly mt-5 border-t-2 border-red-600">
          <td className="w-1/2 self-center text-center">Sede sala prove</td>
          <td className="w-1/2 flex flex-col items-center">
            <p>
              Villa Scheibler MILANO, via Felice Orsini 21, bus 40 da metro 3,
              passante Certosa e Quarto Oggiaro
            </p>
            <img src={VillaScheibler} className="rounded-full w-3/4 flex " />
          </td>
        </tr>
      </table>
    </div>
  );
};

export default WindEnsemble;
